import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import { useCallback } from 'react';
import type { OnActionType } from '../../../../../../context/ActionsProvider/context';
import { useGlobalAppStateStore } from '../../../../../../stores/app/GlobalAppStateStore';
import { InterfaceModes } from '../../../../../../stores/InterfaceStore';
import { SHOULD_NOT_PROPAGATE_UP } from '../../../../const';

export const useControlDevicePermissions = () => {
  const mode = useGlobalAppStateStore().hooks.useMode();

  const { showSnackbar } = useSnackbar();

  const { t } = useTranslation(['interfaces-matrix']);

  const setDevicePermissions: OnActionType = useCallback(() => {
    // no op for web
    if (mode === InterfaceModes.BUILDER) {
      showSnackbar({
        color: 'warning',
        title: t('interfaces-matrix:appActions.ControlDevicePermissions'),
      });
    }
    return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
  }, [showSnackbar, t, mode]);

  return { setDevicePermissions };
};
